import { useEffect, useState } from "react";
import { useFetch } from "app/hooks";
import { makeGet } from "@culturehq/client";

const useOnFetched = ({
  fetching, page, pagination, storyQuestions, setFetchedResponse
}) => useEffect(
  () => {
    if (fetching) return;

    if (page > 1) setFetchedResponse({ pagination, storyQuestions, append: true });
    else setFetchedResponse({ pagination, storyQuestions });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetching]); // Doesn't add "page" prop to avoid side-effects

const initialState = {
  page: 1,
  query: undefined,
  storyQuestions: [],
  pagination: {}
};

const useTrendScreen = () => {
  const [{ page, query, ...rest }, _setState] = useState(initialState);
  const setState = newProps => _setState(prev => ({ ...prev, ...newProps }));
  const handleSearch = query => setState({ query, page: 1 });
  const handleNextPage = () => _setState(prev => {
    if (prev.page >= prev.pagination.totalPages) return prev;
    return { ...prev, page: prev.page + 1 };
  });
  const setFetchedResponse = ({ pagination, storyQuestions, append }) => (
    !append ? setState({ pagination, storyQuestions })
      : _setState(prev => ({
        ...prev,
        pagination,
        storyQuestions: [...prev.storyQuestions, ...storyQuestions]
      })));

  const {
    fetching,
    json: { storyQuestions = [], pagination = {} }
  } = useFetch(
    () => makeGet("/story_questions", { page, query, trendingSummary: true }),
    [page, query]
  );

  useOnFetched({ fetching, page, pagination, storyQuestions, setFetchedResponse });

  return [{ storyQuestions: rest.storyQuestions, fetching }, { handleSearch, handleNextPage }];
};

export default useTrendScreen;
